@if (!hideTitle()) {
  <miq-filter-bar-label [props]="props()"></miq-filter-bar-label>
}
@if (!multi()) {
  <div class="simpleselect_dropdown" [class.has-clear]="displayClearButton">
    <mat-form-field appearance="outline">
      <mat-select
        [disabled]="disabled()"
        disableOptionCentering
        (keydown)="onKeyDown($event)"
        hideSingleSelectionIndicator="true"
        panelClass="select-drop-panel"
        [placeholder]="props().placeholder || ('shared.select' | translate)"
        [formControl]="mainValueControl"
        (selectionChange)="onSelectionChanged($event)"
        >
        <!--Custom Search -->
        @if (props().hasFilter) {
          <ng-container
          *ngTemplateOutlet="
            simpleSelectCustomSearch;
            context: {
              optionsFilterControl: optionsFilterControl,
              filteredOptions: filteredOptions | async,
            }
          "
        ></ng-container>
      }
      @for (option of filteredOptions | async; track option) {
        <mat-option [value]="option[dataKey]">
          <!-- translation required -->
          @if (props().translateOptionsRequired) {
            {{ option.value || option.key || '-' | translate| uppercase }}
          } @else {
            {{ option.value || option.key || '-' | uppercase }}
          }
          <!-- translation NOT required -->
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
}
@if (multi()) {
  <div class="simpleselect_dropdown" [class.has-clear]="displayClearButton">
    <mat-form-field appearance="outline">
      <mat-select
        disableOptionCentering
        hideSingleSelectionIndicator="true"
        panelClass="select-multiple-drop-panel"
        [formControl]="mainValueControl"
        (keydown)="onKeyDown($event)"
        [placeholder]="props().placeholder || ('shared.select' | translate)"
        [disabled]="disabled()"
        (selectionChange)="onSelectionChanged($event)"
        (openedChange)="openedChange($event)"
        multiple
        >
        <!--Custom Search -->
        @if (props().hasFilter) {
          <ng-container
          *ngTemplateOutlet="
            simpleSelectCustomSearch;
            context: {
              optionsFilterControl: optionsFilterControl,
              filteredOptions: filteredOptions | async,
            }
          "
        ></ng-container>
      }
      <!-- Display allKey value if all opt is selected -->
      @if (props().allKey && isAllSelected()) {
        <mat-select-trigger>
          {{ props().allKey }}
        </mat-select-trigger>
      }
      <!-- Show if allKey is present -->
      @if (props().allKey && filteredOptions | async) {
        <mat-option
          class="checkbox-customization"
          [value]="props().allKey"
          >{{ props().allKey }}</mat-option
          >
        }
        @for (option of filteredOptions | async; track option) {
          <mat-option class="checkbox-customization" [value]="option[dataKey]">
            <!-- translation required -->
            @if (props().translateOptionsRequired) {
              {{ (option.value || option.key | translate| uppercase) || '-' }}
            } @else {
              {{ (option.value || option.key | uppercase) || '-' }}
            }
            <!-- translation NOT required -->
          </mat-option>
        }
      </mat-select>
      @if (displayClearButton && (mainValueControl?.value || mainValueControl?.value?.length)) {
        <em
          class="multiselect-clear pi pi-times-circle"
          (click)="clearFilter()"
        ></em>
      }
    </mat-form-field>
  </div>
}

<!-- Custom Input Search -->
<ng-template
  #simpleSelectCustomSearch
  let-optionsFilterControl="optionsFilterControl"
  let-filteredOptions="filteredOptions"
  >
  <div class="ss-search-box-container">
    <input
      #searchInput
      [formControl]="optionsFilterControl"
      type="text"
      (keydown)="onKeyDown($event)"
      autocomplete="off"
      [placeholderLabel]="'shared.find' | translate"
      class="ss-search-box-container-input"
      />
      @if (optionsFilterControl?.value?.length > 0) {
        <mat-icon class="ss-search-box-clear" (click)="clearFilter()"
          >close</mat-icon
          >
      }
    </div>

    <!-- When searching and there are no matches-->
    @if (filteredOptions?.length === 0) {
      <mat-option disabled class="ss-no-matches checkbox-customization">
        {{ 'shared.noMatchFound' | translate}}
      </mat-option>
    }
  </ng-template>
